import React from 'react'
import Img from 'gatsby-image'
import Button from '../../components/Button'
import InfoMap from '../../components/Icons/InfoMap'
import Mail from '../../components/Icons/Mail'
import Phone from '../../components/Icons/Phone'
import Whatsapp from '../../components/Icons/Whatsapp'

import s from './styles.module.css'

const Contact = ({ icon, title, ...rest }) => (
  <a {...rest}>
    <div className={s.info}>
      {icon({ className: s.icon })}
      <p className={s.infoTitle}>{title}</p>
    </div>
  </a>
)

export default class ContactForm extends React.Component {
  state = {
    name: '', // eslint-disable-line react/no-unused-state
    email: '', // eslint-disable-line react/no-unused-state
    message: '' // eslint-disable-line react/no-unused-state
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.message != this.props.message) {
      this.setState({ message: nextProps.message })
    }
  }

  onChange = field => e => {
    this.setState({
      [field]: e.target.value
    })
  }

  render() {
    const { image } = this.props

    return (
      <div className={s.contact} id="contact-form">
        {image ? (
          <Img
            outerWrapperClassName={s.imageWrapper}
            className={s.image}
            sizes={image.sizes}
          />
        ) : null}
        <h1 className={s.title}>Contact Us</h1>
        <form
          name="contact"
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          className={s.form}
        >
          <input type="hidden" name="form-name" value="contact" />
          <label htmlFor="contact-name" className={s.hiddenLabel}>
            Name
          </label>
          <input
            className={s.input}
            type="text"
            onChange={this.onChange('name')}
            name="name"
            placeholder="Name"
            id="contact-name"
          />
          <label htmlFor="contact-email" className={s.hiddenLabel}>
            Email
          </label>
          <input
            className={s.input}
            type="email"
            onChange={this.onChange('email')}
            name="email"
            placeholder="Email"
            id="contact-email"
            pattern="[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*"
            required
          />
          <label htmlFor="contact-message" className={s.hiddenLabel}>
            Message
          </label>
          <textarea
            className={s.textarea}
            onChange={this.onChange('message')}
            name="message"
            placeholder="Message"
            id="contact-message"
            value={this.state.message}
            required
          />

          <Button className={s.button}>Book now</Button>
        </form>

        <div className={s.contactInfo}>
          <Contact icon={InfoMap} title="Zaklopatica 21, Lastovo" />
          <Contact
            icon={Mail}
            title="info@augustainsula.com"
            href="mailto:info@augustainsula.com"
          />
          <Contact
            icon={Phone}
            title={`+385 985 718 84
          +385 959 009 778`}
            href="tel: +385 985 718 84"
          />
          <Contact
            icon={Whatsapp}
            title={`+385 985 718 84`}
            href="https://api.whatsapp.com/send?phone=38598571884"
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.js